<template>
  <div class="mm__dialog">
    <!-- 背景遮罩层 -->
    <div class='dialog-mark' v-if='showFlag'></div>
    <!-- 弹出框 -->
    <transition name='drop'>
      <div class='dialog__container' v-if='showFlag' ref='dialog'>
        <div class="dialog__title">
          <p class="title">{{titleText}}</p>
          <span class='dialog__close'>
            <c-iconButton @click='close'>
              <svg class='icon icon-16' aria-hidden='true'>
                <use xlink:href='#icon-c_7'></use>
              </svg>
            </c-iconButton>
          </span>
        </div>
        <div class='dialog__body'>
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'c-mm-dialog',
  props: {
    // 展示变量
    showFlag: { default: false, type: Boolean },
    // 提示文案
    titleText: { default: '', type: String },
  },
  methods: {
    close() {
      this.$emit('dialogOnClose', true);
    },
  },
};

</script>
<style>
.dialog-mark {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .4)
}
.drop-enter-active {
  animation: drop-in .3s;
}
.drop-leave-active {
  animation: drop-in .3s reverse;
}
@keyframes drop-in {
  0% {
    top: 35%;
    opacity: 0.7
  }
  100% {
    opacity: 1;
  }
}
.dialog__container {
  transform: 0.3s transition;
  height: auto;
  position: fixed;
  z-index: 1000;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  background-color: #fff;
  /* padding: 20px;
  box-sizing: border-box; */
}
.dialog__title {
  height: 80px;
  line-height: 80px;
  font-size: 21px;
  color: #1C2143;
  letter-spacing: 0.06px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  box-sizing: border-box;
  border-bottom: 1px solid #F3F3F3;
}
.dialog__close {
  cursor: pointer;
}
.dialog__body {
  min-height: 100px;
  padding: 22px 20px 30px;
  box-sizing: border-box;
}
</style>
